module.exports = __webpack_public_path__ + "static/media/Trading-logo.85dfd825.png";